import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Row } from 'antd';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { BackBtn } from '@comm/BackBtn';
import FlowOp from '@comm/workflow/submitOp';
import util from '@util/index';
import { queryDeleteBack, querySaveBack } from '@api/incubator/back';
import { queryOrgList } from '@api/core/org';
import { round } from 'echarts/lib/util/number';
import ModalFileList from '../comm/ModalFileList';
import ModalPayableList from '../comm/ModalPayableList';
import TableFile from '../comm/TableFile';
import TablePayable from '../comm/TablePayable';
import SelectCustom from '../comm/SelectCustom';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: this.props.data ? this.props.data.files : [],
      payableList: this.props.data ? this.props.data.payables : [],
      customUuid: this.props.data ? this.props.data.customUuid : '',
      payableVisible: false,
      submiting: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getOrgList();
  }

  getOrgList = () => {
    const { data, incuInfo } = this.props;
    queryOrgList({
      type: 1,
      uuid: 'F58BDBC0066B4FB0A8E54BCAF77DA727',
    }).then(res => {
      if (data && data.companyUuid) {
        this.initCompany(res.data, data.companyUuid);
      } else if (incuInfo.companyUuid) {
        this.initCompany(res.data, incuInfo.companyUuid);
      }
    });
  };

  // 初始化开票公司名称
  initCompany = (org, key) => {
    const currentCompany = org.find(item => item.uuid === key);
    this.setState({
      company: currentCompany ? currentCompany.name : '',
    });
    this.props.form.setFieldsValue({
      company: currentCompany ? currentCompany.name : '',
    });
  };

  componentWillReceiveProps(nextProps) {}

  backSave = params => {
    this.setState({
      submiting: true,
    });
    querySaveBack(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/back_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleDelete = uuid => {
    queryDeleteBack({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/back_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  handlepayableVisible = flag => {
    this.setState({
      payableVisible: !!flag,
    });
  };

  handleChooseFile = params => {
    this.setState({
      fileList: params,
      showFileTips: params.length === 0,
    });
  };

  handleChooseIncome = params => {
    this.setState({
      payableList: params,
      showFileTips: params.length === 0,
    });
  };

  validateFile = () => {
    const { fileList } = this.state;
    if (!fileList.length) {
      message.warn('没有选择附件！');
      this.setState({
        showFileTips: true,
      });
      return false;
    }
    return true;
  };

  submit = op => e => {
    if (e) {
      e.preventDefault();
    }
    const { data } = this.props;
    const { fileList, payableList } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.validateFile()) {
          return;
        }
        if (data && data.uuid) {
          values.uuid = data.uuid;
        }
        const params = {
          ...values,
          price: round(
            payableList.reduce((prev, curr) => prev + curr.price, 0),
            2,
          ),
          files: fileList,
          payableUuids: payableList.map(item => item.uuid),
        };
        if (op === 'audit') {
          this.backSave(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  handleComChange = (e, option) => {
    this.props.form.setFieldsValue({ company: option.props.children });
  };

  handleCustomChange = (e, option) => {
    this.customUuid = e;
    this.setState({
      customUuid: e,
    });
    this.props.form.setFieldsValue({ custom: option.props.children });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      fileVisible,
      showFileTips,
      fileList,
      payableList,
      customUuid,
      payableVisible,
      company,
      submiting,
    } = this.state;
    const { data, incuInfo } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };

    const ItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    getFieldDecorator('company', { initialValue: data ? data.company : '' });
    getFieldDecorator('custom', { initialValue: data ? data.custom : '' });
    getFieldDecorator('companyUuid', {
      initialValue: data ? data.companyUuid : incuInfo.companyUuid,
    });
    return (
      <Form>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <FlowOp handleClick={this.submit} loading={submiting} />
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <Card title="账单退款申请">
          <Row>
            <Col span={10}>
              <FormItem label="付款公司名称" {...ItemLayout}>
                {company}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="客户名称" {...ItemLayout}>
                {getFieldDecorator('customUuid', {
                  rules: [{ required: true, message: '请选择客户!' }],
                  initialValue: data ? data.customUuid : '',
                })(
                  <SelectCustom
                    onChange={this.handleCustomChange}
                    incubatorUuid={data ? data.incubatorUuid : this.props.params.uuid}
                    customName={data ? data.custom : ''}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="账单" {...ItemLayout2}>
                {customUuid ? (
                  <a onClick={() => this.handlepayableVisible(true)}>选择账单</a>
                ) : null}
                {showFileTips ? (
                  <span style={{ color: 'red', paddingLeft: '10px' }}>相关账单必选！</span>
                ) : null}
                {payableList.length > 0 ? (
                  <TablePayable
                    dataSource={payableList}
                    handleChooseData={this.handleChooseIncome}
                  />
                ) : null}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="退款金额" {...ItemLayout}>
                {util.numberFormat(payableList.reduce((prev, curr) => prev + curr.price, 0))}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="公司抬头" {...ItemLayout}>
                {getFieldDecorator('accountName', {
                  rules: [{ required: true, message: '请输入公司抬头!' }],
                  initialValue: data ? data.accountName : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="银行账号" {...ItemLayout}>
                {getFieldDecorator('account', {
                  rules: [{ required: true, message: '请输入银行账号!' }],
                  initialValue: data ? data.account : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="开户行" {...ItemLayout}>
                {getFieldDecorator('accountBank', {
                  rules: [{ required: true, message: '请输入开户行!' }],
                  initialValue: data ? data.accountBank : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="相关附件" {...ItemLayout2} style={{ marginBottom: '0' }}>
                {customUuid ? <a onClick={() => this.handleFileVisible(true)}>选择附件</a> : null}
                {showFileTips ? (
                  <span style={{ color: 'red', paddingLeft: '10px' }}>附件必须上传！</span>
                ) : null}
                {fileList.length > 0 ? (
                  <TableFile dataSource={fileList} handleChooseFile={this.handleChooseFile} />
                ) : null}
              </FormItem>
            </Col>
            <Col span={20} style={{ marginBottom: '16px' }}>
              <Col span={3} />
              <Col span={20}>
                <p style={{ color: 'red', whiteSpace: 'nowrap' }}>
                  请核实该笔退款收入是否已开具发票/收据： 若已开具请收回原件，并附件上传；
                  若原件已丢失，请客户提供丢失证明文件并加盖公章，并附件上传。
                </p>
              </Col>
            </Col>
            <Col span={20}>
              <FormItem label="退款申请说明" {...ItemLayout2}>
                {getFieldDecorator('reason', {
                  rules: [{ required: true, message: '请输入退款申请说明!' }],
                  initialValue: data ? data.reason : '',
                })(
                  <Input.TextArea
                    placeholder="退款申请说明"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
        {payableVisible ? (
          <ModalPayableList
            incubatorUuid={incuInfo.uuid}
            customUuid={customUuid}
            visible={payableVisible}
            selectedRows={payableList}
            handleCancel={this.handlepayableVisible}
            handleChooseData={this.handleChooseIncome}
          />
        ) : null}
        {fileVisible ? (
          <ModalFileList
            customUuid={customUuid}
            fileVisible={fileVisible}
            selectedRows={fileList}
            handleCancel={this.handleFileVisible}
            handleChooseFile={this.handleChooseFile}
          />
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  incuInfo: state.incubator_base,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/incubator/back/FormBase.js